@if (!cs.step3.skipped) {
  <div class="summary-part"
    >
    <div class="summary-part-title">
      <div class="title">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP3.TAB' | translate }}</div>
      <div class="action"
      (click)="gotoStep(2)">{{ 'BUTTON.MODIFY' | translate }}</div>
    </div>
    @if (cs.step3.valid) {
      <div class="summary-part-row">
        <div class="summary-field value"
        [innerHTML]="cs.step3.message"></div>
      </div>
    }
    @if (!cs.step3.valid) {
      <div class="summary-part-row">
        {{ 'ITSM.CREATESERVICEREQUEST.STEPS.NOTCOMPLETED' | translate }}
      </div>
    }
    <hr />
  </div>
}
